import { debounce as ldb } from 'lodash-es';

// TODO should bind with this;

export default function debounce(delay = 0) {
  return (target, key, descriptor) => {
    const fn = descriptor.value;
    descriptor.value = ldb(fn, delay);
    return descriptor;
  };
}
